import React from 'react'

import quickAdd_createPage from "../../../../../app/quick-add/sections/structure/page/helpers/create-page"
import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"

type Props = {
    level?      : number
    parentId?   : ID

    templateId? : ID

    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddPage"
const debug = false

export default function NavigationMenuItemAddPage(props: Props) {

    const projectIcon = 'page'

    const onCommit = async (value?: string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        let project
        if (props.templateId) {
            const newProjectData = {
                toCompanyId         : gd.companyId,
                toProjectId         : props.parentId,
                templateId          : props.templateId,
                name                : value,
                owner               : gd.user.id,
                color               : gd.session.projects.get(props.parentId!)?.color,
            }

            const {projectId} = await gd.api.Project.newProjectFromTemplate(newProjectData).promise()
            project = gd.session.projects.get(projectId)!
        } else {
            project = await quickAdd_createPage({
                company         : gd.companyId,
                parentProject   : props.parentId,
                name            : value,
                owner           : gd.user.id,
                color           : gd.session.projects.get(props.parentId)?.color,
            })
        }

        gd.goTo(project!.url)
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}